const addTogglePrevNextButtonsActive = (emblaApi, prevButton, nextButton) => {
  const togglePrevNextButtonsState = () => {
    emblaApi.canScrollPrev() ? prevButton.removeAttribute("disabled") : prevButton.setAttribute("disabled", "disabled");
    emblaApi.canScrollNext() ? nextButton.removeAttribute("disabled") : nextButton.setAttribute("disabled", "disabled");
  };

  emblaApi.on("select", togglePrevNextButtonsState).on("init", togglePrevNextButtonsState).on("reInit", togglePrevNextButtonsState);

  return () => {
    prevButton.removeAttribute("disabled");
    nextButton.removeAttribute("disabled");
  };
};

const addPrevNextButtonsClickHandlers = (emblaApi, prevButton, nextButton, onButtonClick) => {
  const scrollPrev = () => {
    emblaApi.scrollPrev();
    if (onButtonClick) {
      onButtonClick(emblaApi);
    }
  };
  const scrollNext = () => {
    emblaApi.scrollNext();
    if (onButtonClick) {
      onButtonClick(emblaApi);
    }
  };
  prevButton.addEventListener("click", scrollPrev, false);
  nextButton.addEventListener("click", scrollNext, false);

  const removeTogglePrevNextButtonsActive = addTogglePrevNextButtonsActive(emblaApi, prevButton, nextButton);

  return () => {
    removeTogglePrevNextButtonsActive();
    prevButton.removeEventListener("click", scrollPrev, false);
    nextButton.removeEventListener("click", scrollNext, false);
  };
};

export { addPrevNextButtonsClickHandlers };
